export default {
  borderRadius: 4,
  typography: {
    fontSize: 16,
    lineHeight: 16
  },
  mode: {
    dark: {
      color: 500,
      hover: 400,
      label: 100,
      textColor: 100
    },
    light: {
      color: 500,
      hover: 600,
      label: 700,
      textColor: 700
    }
  },
  padding: {
    top: 12,
    right: 16,
    bottom: 12,
    left: 16
  },
  height: 42
}
